/**
 * Amount Display Component
 *
 * Reusable component to display the total amount at the top of screens
 */

import { CancelButton } from './CancelButton/CancelButton';
import styles from './AmountDisplay.module.css';

interface AmountDisplayProps {
  amount: number;
  currency: string;
  onCancel?: () => void;
  cancelDisabled?: boolean;
}

export const AmountDisplay = ({
  amount,
  currency,
  onCancel,
  cancelDisabled = false,
}: AmountDisplayProps) => {
  const formatAmount = (amount: number, currency: string): string => {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency,
    }).format(amount / 100);
  };

  return (
    <div
      className={
        onCancel ? styles.amountSectionWithCancel : styles.amountSection
      }
    >
      <div className={styles.amountInfo}>
        <span className={styles.amountLabel}>Total amount:</span>
        <span className={styles.amount}>{formatAmount(amount, currency)}</span>
      </div>
      {onCancel && (
        <CancelButton onClick={onCancel} disabled={cancelDisabled} />
      )}
    </div>
  );
};
